export const endpoints = {
  prod: "https://api.animaapp.com",
  canary: "https://canary-api.animaapp.com",
  local: "http://localhost:5007",
};

export type Environment = keyof typeof endpoints;
